import { Component, ViewChild } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { MedicalAdviceService } from '../../../shared/components/medical-advice/services/medical-advice.service';
import { ParameterService } from '../../../shared/services/parameter/parameter.service';
import { MedicalAdviceComponent } from '../../../shared/components/medical-advice/medical-advice.component';

@Component({
  selector: 'app-medical-advice-list',
  templateUrl: './medical-advice.component.html',
  styleUrl: './medical-advice.component.scss',
})
export class MedicalAdviceListComponent {
  @ViewChild('medicalAdviceDialog')
  medicalAdviceDialog: MedicalAdviceComponent;

  callReasons: any[] = [];
  loading: boolean = false;
  priceInfoShowAddress: boolean = false;
  filterCollaps: boolean = false;

  items: any[] = [];
  first = 0;
  rows = 10;
  totalRecords: number = 0;

  filter: {
    search: string;
    date: Date | null;
    callPhone: string;
    callReason: any;
  } = {
    search: '',
    date: null,
    callPhone: '',
    callReason: null,
  };

  constructor(
    private readonly service: MedicalAdviceService,
    private readonly parameterService: ParameterService
  ) {
    this.parameterService
      .getParameterValues('data-group', 'medicalAdviceCallReasons')
      .subscribe((res) => {
        this.callReasons = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.id };
        });
      });
  }

  clearFilter() {
    this.filter = {
      date: null,
      search: '',
      callPhone: '',
      callReason: null,
    };
    this.getList({});
  }

  initilize(item?: any) {
    this.medicalAdviceDialog.initilize(item);
  }

  async getList(event: TableLazyLoadEvent) {
    this.loading = true;
    const filterObj = {
      search: this.filter.search,
      searchBy: ['callNameSurname', 'complaint', 'userNote'],
      'filter.callPhone': this.filter.callPhone,
      'filter.callReason': this.filter.callReason,
      'filter.createdAt': this.filter?.date
        ? `$gte:${this.filter.date.toISOString()}`
        : null,
    };

    this.service.getFilter(event, filterObj).subscribe({
      next: (res) => {
        this.items = res.items;
        this.totalRecords = res.total;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  onCreatedNewItem(event: any) {
    if (event) {
      this.items.push({
        ...event,
        personNo: {
          id: event?.personNo?.id,
          firstName: event?.personNo?.firstName,
          lastName: event?.personNo?.lastName,
        },
      });
      this.totalRecords = this.totalRecords + 1;
    }
  }

  onUpdatedNewItem(event: any) {
    if (event?.id) {
      const index = this.items.findIndex((item) => item.id === event.id);
      if (index !== -1) {
        this.items[index] = event;
        this.items[index].personNo = {
          id: event?.personNo?.id,
          firstName: event?.personNo?.firstName,
          lastName: event?.personNo?.lastName,
        };
      }
    }
  }

  formattedPrice(value: any): number {
    return Number(value) || 0; // Ensure it's a valid number
  }
}
